module.exports = __webpack_public_path__ + "img/Step4m.83bfd342.png";